module.exports = __webpack_public_path__ + "static/media/sa.01b40f18.svg";